export default __webpack_public_path__ + "static/media/Padsoles of Deadly Guile.5a3e6dfb.jpg";